// extracted by mini-css-extract-plugin
module.exports = {"HowItWorks":"_2f4jwwo1","Container":"_224R7OQb","Title":"_3r7_s9MI","Wrapper":"_2VciKqL-","Column":"_1xpI7QXV","Image":"_2KPZa57r","StepTitle":"_3LL8zzeN","Description":"_3UAElQmX","Underline":"cdFcr0vr"};
    if(module.hot) {
      // 1746735782621
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  